module.exports = __webpack_public_path__ + "static/media/pitch.ceeef3ec.jpg";